import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DataSessionService } from '../../../core/services/data-session.service';
import { ModalData } from '../../shared/type/modal';
import { SelectData } from '../../shared/type/input';
import { Observable, of } from 'rxjs';
import { ContentResponse } from '../../contents/type/content';

@Injectable({ providedIn: 'root' })
export class ContentUpdateService {
  private readonly _http = inject(HttpClient);
  private readonly _dataSessionService = inject(DataSessionService);

  updateModalData = (action: () => void): ModalData => {
    return {
      icon: 'icon-information-circle',
      title: 'Guardar cambios',
      subtitle: '¿Está seguro que quiere guardar los cambios realizados?',
      leftButton: {
        label: 'No, cancelar',
        action: () => {},
      },
      rigthButton: { label: 'Si, continuar', action: () => action() },
    };
  };

  contentTypeSearchData: SelectData<ContentTypeValue>[] = [
    { value: 'privado', label: 'Privado' },
    { value: 'publico', label: 'Público' },
  ];

  statusContentSearchData: SelectData<StatusContentValue>[] = [
    { value: '1', label: 'Activo' },
    { value: '2', label: 'Inactivo' },
    { value: '0', label: 'Oculto' },
  ];

  getManageContents = (params?: string): Observable<ContentResponse> => {
    let subUrl = '/manage/contents';
    if (params) {
      subUrl += params;
    }
    return this._http.get<ContentResponse>(
      `${this._dataSessionService.baseUrl}${subUrl}`
    );
  };

  getAllManagers = (): Observable<ManagerResponse> => {
    return this._http.get<ManagerResponse>(
      `${this._dataSessionService.baseUrl}/manage/users-int`
    );
  };

  getContentById = (content: string): Observable<ContentByIdResponse> => {
    return this._http.get<ContentByIdResponse>(
      `${this._dataSessionService.baseUrl}/manage/content/${content}`
    );
  };

  postContentById = (content: string, body: any): Observable<any> => {
    return this._http.post<any>(
      `${this._dataSessionService.baseUrl}/manage/content/${content}`, body
    );
  };
}
